import { put, select, takeLatest } from "redux-saga/effects";
import {
  both,
  complement,
  findIndex,
  includes,
  not,
  path,
  pathEq,
  propEq,
  without,
} from "ramda";

import {
  type MedidaSelecionada,
  GRUPAMENTO_MEDIDAS_PERSONALIZADAS,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_NOME,
  ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_USUARIO,
  MODO_APP_NORMAL,
} from "../model";

import {
  adicionarMedidasComDescricao,
  adicionarMedidaUsuario,
  atualizarMedidasUsuario,
  carregarMedidasUsuario,
  excluirMedidaSelecionada,
  getEdicaoMedida,
  getIdMedidaSelecionada,
  getMedidaSelecionadaMedidaUsuario,
  getMedidasSelecionadas,
  setSeletorAberto,
  getModoApp,
} from "../state";

function* carregarMedidaUsuarioSaga({ api }) {
  yield takeLatest("ATUALIZAR_MEDIDAS_USUARIO", function*() {
    try {
      const medidasUsuario = yield api.obterMedidasUsuario();
      yield put(carregarMedidasUsuario(medidasUsuario));
    } catch (error) {}
  });

  yield takeLatest("SELECIONAR_MEDIDA", function*(action) {
    const { idMedidaSelecionada } = action;

    if (
      // eslint-disable-next-line eqeqeq
      ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_USUARIO == idMedidaSelecionada
    ) {
      yield put(atualizarMedidasUsuario());
    }
  });

  yield takeLatest("SELECIONAR_GRUPAMENTO_MEDIDA", function*(action) {
    const { grupamento } = action;

    if (GRUPAMENTO_MEDIDAS_PERSONALIZADAS === grupamento) {
      const modoApp = yield select(getModoApp);

      if (modoApp === MODO_APP_NORMAL) {
        const medidasSelecionadas = yield select(getMedidasSelecionadas);
        const possuiOutrasMedidas = medidasSelecionadas
          .filter(
            complement(
              pathEq(
                ["medida", "idConfiguracaoRelatorio"],
                ID_CONFIGURACAO_RELATORIO_MEDIDA_NOME
              )
            )
          )
          .map(path(["medida", "grupamentoMedida", "nome"]))
          .some(grupamento => grupamento !== GRUPAMENTO_MEDIDAS_PERSONALIZADAS);

        if (possuiOutrasMedidas) {
          yield put(setSeletorAberto("autoCompleteMedidas", true));
        }
      }

      const idMedidaSelecionada = yield select(getIdMedidaSelecionada);

      if (
        ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_USUARIO === idMedidaSelecionada
      ) {
        yield put(atualizarMedidasUsuario());
      }
    }
  });

  yield takeLatest("ADICIONAR_MEDIDA_USUARIO", function*(action) {
    const { medidasSelecionadas: medidas } = action;

    const medidasSelecionadas = yield select(getMedidasSelecionadas);

    const idsMedidasUsuarioSelecionadas = medidasSelecionadas
      .filter(
        pathEq(
          ["medida", "idConfiguracaoRelatorio"],
          ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_USUARIO
        )
      )
      .map(medida => medida.idMedidaUsuario);

    let idsMedidaUsuarioSemEditada;
    const medidaSendoEditada = yield select(getEdicaoMedida);

    if (medidaSendoEditada && medidaSendoEditada.indiceMedidaEditada) {
      const medidaEditada =
        medidasSelecionadas[medidaSendoEditada.indiceMedidaEditada];

      if (medidaEditada && medidaEditada.idMedidaUsuario) {
        idsMedidaUsuarioSemEditada = without(
          [medidaEditada.idMedidaUsuario],
          idsMedidasUsuarioSelecionadas
        );
      }
    }

    const idsMedidasUsuario =
      medidaSendoEditada && medidaSendoEditada.indiceMedidaEditada
        ? idsMedidaUsuarioSemEditada
        : idsMedidasUsuarioSelecionadas;

    const novasMedidas = medidas.filter(medida =>
      not(includes(medida.idMedidaUsuario, idsMedidasUsuario))
    );

    yield put(adicionarMedidasComDescricao(novasMedidas));
  });

  yield takeLatest("EXCLUIR_MEDIDA_USUARIO", function*(action) {
    const { idMedidaUsuario } = action;

    const medidasSelecionadas = yield select(getMedidasSelecionadas);

    const indiceMedidaExclusao = findIndex(
      both(
        pathEq(
          ["medida", "idConfiguracaoRelatorio"],
          ID_CONFIGURACAO_RELATORIO_MEDIDA_MEDIDA_USUARIO
        ),
        propEq("idMedidaUsuario", idMedidaUsuario)
      ),
      medidasSelecionadas
    );

    if (indiceMedidaExclusao !== -1) {
      yield put(excluirMedidaSelecionada(indiceMedidaExclusao));
    }
  });

  yield takeLatest("IMPORTAR_MEDIDA_USUARIO", function*(action) {
    const { idMedidaUsuario } = action;

    const medidaMedidaUsuario: MedidaSelecionada = yield select(
      getMedidaSelecionadaMedidaUsuario
    );

    yield put(
      adicionarMedidaUsuario([{ ...medidaMedidaUsuario, idMedidaUsuario }])
    );
  });
}

export default carregarMedidaUsuarioSaga;
